module.exports = __webpack_public_path__ + "static/media/improve_acc_eng_01.9a7a2225.png";